import React from 'react';

export default function MapLoadingSkeleton() {
  return (
    <div className="w-full h-full flex items-center justify-center bg-slate-100 relative overflow-hidden">
      {/* Skeleton map tiles */}
      <div className="absolute inset-0 animate-pulse">
        <div className="w-full h-full bg-gradient-to-br from-slate-200 via-slate-100 to-slate-200" />
        {/* Fake tile grid lines */}
        <div className="absolute inset-0 opacity-30">
          {[0, 1, 2, 3, 4]?.map((i) => (
            <div
              key={`hline-${i}`}
              className="absolute w-full h-px bg-slate-300"
              style={{ top: `${i * 25}%` }}
            />
          ))}
          {[0, 1, 2, 3, 4, 5]?.map((i) => (
            <div
              key={`vline-${i}`}
              className="absolute h-full w-px bg-slate-300"
              style={{ left: `${i * 20}%` }}
            />
          ))}
        </div>
      </div>
      {/* Loading indicator */}
      <div className="relative z-10 flex flex-col items-center gap-3 bg-card/90 rounded-2xl px-6 py-5 shadow-float border border-border">
        <div className="w-8 h-8 rounded-full border-3 border-primary border-t-transparent animate-spin" style={{ borderWidth: '3px' }} />
        <p className="text-sm font-semibold text-foreground">Loading map…</p>
        <p className="text-xs text-muted-foreground">Fetching West Delhi rates</p>
      </div>
    </div>
  );
}